import React from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";

import { Administration } from "pages/app/Administration";
import {
  ContainerAdmin,
  ContainerLeftMenu,
} from "pages/app/Administration/styles";

const ContentArea = styled.div`
  width: 100%;
  height: calc(100vh - 64px);
  overflow: hidden;
`;

export const AdminLayout: React.FC = () => {
  return (
    <ContainerAdmin>
      <ContainerLeftMenu>
        <Administration />
      </ContainerLeftMenu>
      <ContentArea>
        <Outlet />
      </ContentArea>
    </ContainerAdmin>
  );
};

export default AdminLayout;
